<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-01-20 10:58:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/index.vue
-->
<template>
  <div class="purchase_con">
    <title-bar-back :title="'确认订单'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 头部信息 -->
    <!-- 非鲜奶卡 -->
    <div v-if="preCheckout.orderType !== 2">
      <!-- 地址 -->
      <pur-address
        v-if="preCheckout.orderType !== 2"
        :isAllow="preCheckout.isAllow"
        :addressConstant="preCheckout.addressConstant"
        :address="address"
        @goAddressList="goAddressList"
      />
      <!-- 商品信息 -->
      <div class="product_con_det">
        <shop-header
          @goExplain="goExplain"
          :switchOrderType="preCheckout.orderType"
          :storeName="preCheckout.storeName"
        />
        <div v-for="(item, index2) in preCheckout.itemList" :key="index2">
          <!-- 商品信息 -->
          <order-product-list
            :listIndex="index2"
            :pageShow="false"
            :item="item"
            class="pro_padd"
          />
          <!-- 赠品 -->
          <div
            v-if="item.giftList && item.giftList.length"
            class="free_product_list"
          >
            <free-product
              v-for="(item, index) in item.giftList"
              :key="index"
              :showLine="false"
              :freeProduct="item"
              :class="{ border_top1px: index === 0 }"
              class="free_pad"
            />
          </div>
        </div>
      </div>
      <!-- 鲜奶时间 -->
      <milk-date
        v-if="preCheckout.orderType === 1"
        @goChooseDate="goChooseDate"
        :item="preCheckout"
      />
      <!-- 留言 -->
      <mes-det @goNote="goNote" />
    </div>
    <!-- 鲜奶卡 -->
    <div v-if="preCheckout.orderType === 2">
      <shop-header
        :switchOrderType="preCheckout.orderType"
        :storeName="preCheckout.storeName"
        :showExp="false"
      />
      <milk-card />
      <!-- 赠品 -->
      <div
        v-if="
          preCheckout.itemList[0].giftList &&
            preCheckout.itemList[0].giftList.length
        "
        class="free_product_list"
      >
        <free-product
          v-for="(item, index) in preCheckout.itemList[0].giftList"
          :key="index"
          :showLine="false"
          :freeProduct="item"
          :class="{ border_top1px: index === 0 }"
          class="free_pad"
        />
      </div>
    </div>
    <!-- 订单价格 -->
    <order-price />
    <!-- 协议 -->
    <div
      class="font12 font_weight400 colo037 line_height_17 det_all"
      @click="goOrder1"
    >
      <span>确认支付即表示同意</span>
      <span class="det_color">《用户购买协议》</span>
      <span>和</span>
      <span class="det_color">《服务协议及告知书》</span>
    </div>
    <div class="bottom_margin"></div>
    <!-- 底部按钮 -->
    <pur-btn @submitBtn="submitBtn" />
    <!-- 实名认证 -->
    <id-num-action-sheet
      v-if="showIdSheet"
      @closeSheet="closeSheet"
      @sure="sure"
      @inputName="inputName"
      @inputId="inputId"
    />
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import PurAddress from "./components/PurAddress";
import ShopHeader from "./components/ShopHeader";
import OrderProductList from "../list/components/OrderProductList";
import FreeProduct from "../../cart/components/FreeProduct";
import OrderPrice from "./components/OrderPrice";
import MesDet from "./components/MesDet";
import PurBtn from "./components/PurBtn";
import MilkDate from "./components/MilkDate";
import IdNumActionSheet from "./components/IdNumActionSheet";
import MilkCard from "./components/MilkCard";
export default {
  name: "Purchase",
  components: {
    TitleBarBack,
    PurAddress,
    ShopHeader,
    OrderProductList,
    FreeProduct,
    OrderPrice,
    MesDet,
    PurBtn,
    MilkDate,
    IdNumActionSheet,
    MilkCard
  },
  data() {
    return {
      showIdSheet: false,
      idList: [],
      idName: "",
      idCard: "",
      address: {}
    };
  },
  watch: {
    address() {
      // console.log(this.address, "1111watch");
    }
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.back();
      localStorage.removeItem("pur-note");
      localStorage.removeItem("pur-address");
      localStorage.removeItem("mall-wap-pur-choosedate");
    },
    getData() {
      // preCheckout
      let params = {};
      if (parseInt(this.$route.query.buyNow) !== 1) {
        // 购物车
        params = {
          idList: JSON.parse(this.$route.query.idList),
          buyNow: parseInt(this.$route.query.buyNow),
          slug: this.slug,
          addressId: localStorage.getItem("pur-address")
            ? JSON.parse(localStorage.getItem("pur-address")).id
            : ""
        };
      } else {
        // 商详
        params = {
          item: {
            spuId: this.$route.query.spuId,
            skuId: this.$route.query.skuId,
            amount: this.$route.query.amount,
            giftCarts: JSON.parse(this.$route.query.giftCarts)
          },
          buyNow: this.$route.query.buyNow,
          slug: this.slug,
          addressId: localStorage.getItem("pur-address")
            ? JSON.parse(localStorage.getItem("pur-address")).id
            : ""
        };
      }
      this.$store
        .dispatch("cart/preCheckout", { params })
        .then(res => {
          // console.log(333333333);
          this.idName = res.idcardName;
          this.idCard = res.idcardNo;
          if (localStorage.getItem("pur-address")) {
            this.address = JSON.parse(localStorage.getItem("pur-address"));
            // console.log(this.address, "local地址");
            // if (
            //   Object.keys(this.address).length === 0 &&
            //   this.address.constructor === Object
            // ) {
            //   // 弹出选择地址框
            //   console.log("弹出选择地址框");
            // }
          } else {
            if (res.address && res.address !== null) {
              this.address = JSON.parse(JSON.stringify(res.address));
              // console.log(this.address, "接口地址");
              // if (
              //   Object.keys(this.address).length === 0 &&
              //   this.address.constructor === Object
              // ) {
              //   // 弹出选择地址框
              //   console.log("弹出选择地址框");
              // }
            }
          }
        })
        .catch(() => {});
    },
    // 提交
    submitBtn() {
      // 是否需要实名认证
      if (this.preCheckout.isRequiredRealName) {
        this.showIdSheet = true;
      } else {
        this.checkOrder();
        // console.log(111);
      }
    },
    closeSheet() {
      this.showIdSheet = false;
    },
    goAddressList() {
      this.$router.push({
        path: "/mine/addresslist",
        query: {
          previousPage: "pur"
        }
      });
    },
    // inputName
    inputName(name) {
      // console.log(name, "name");
      this.idName = name;
    },
    inputId(idNum) {
      // console.log(idNum, "id");
      this.idCard = idNum;
    },
    // 下单提交
    checkOrder() {
      // 普通商品 购物车下单
      let params = {};
      if (!parseInt(this.$route.query.buyNow)) {
        params = {
          idList: JSON.parse(this.$route.query.idList),
          buyNow: parseInt(this.$route.query.buyNow),
          userMessage: localStorage.getItem("pur-note") || "",
          slug: this.slug
        };
        // console.log(params, "checkout 1");
      } else {
        params = {
          item: {
            spuId: this.$route.query.spuId,
            skuId: this.$route.query.skuId,
            amount: this.$route.query.amount,
            giftCarts: JSON.parse(this.$route.query.giftCarts)
          },
          buyNow: this.$route.query.buyNow,
          userMessage: localStorage.getItem("pur-note") || "",
          slug: this.slug
        };
        // console.log(params, "checkout 2");
      }
      if (
        !(
          Object.keys(this.address).length === 0 &&
          this.address.constructor === Object
        )
      ) {
        params.addressId = this.address.id;
      } else {
        params.addressId = "";
      }
      if (this.preCheckout.isRequiredRealName) {
        params.buyerIdcardName = this.idName;
        params.buyerIdcardNo = this.idCard;
      }
      if (this.preCheckout.orderType === 1) {
        // preCheckout.orderType === 1
        // deliveryPlanTime
        params.deliveryPlanTime =
          localStorage.getItem("mall-wap-pur-choosedate") ||
          this.preCheckout.deliveryPlanTime;
      }
      // console.log(params, "checkout 3");
      this.$store
        .dispatch("cart/checkout", { params })
        .then(res => {
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn: res.orderSn
            }
          });
          localStorage.removeItem("pur-note");
          localStorage.removeItem("pur-address");
          localStorage.removeItem("mall-wap-pur-choosedate");
        })
        .catch(() => {});
    },
    // 提交
    sure() {
      // checkout
      // checkIdentityIdcard 实名认证
      if (this.preCheckout.isRequiredRealName) {
        if (!this.idName && !this.preCheckout.idcardName) {
          this.$toast("请输入实名姓名");
          return;
        }
        if (!this.idCard && !this.preCheckout.idcardNo) {
          this.$toast("请输入实名身份证号");
          return;
        }
        const paramsID = {
          idcardName: this.idName || this.preCheckout.idcardName,
          idcardNo: this.idCard || this.preCheckout.idcardNo
        };
        this.$store
          .dispatch("cart/checkIdentityIdcard", { params: paramsID })
          .then(() => {
            this.checkOrder();
          })
          .catch(() => {
            this.$toast("请输入正确的信息");
          });
      } else {
        this.checkOrder();
      }
    },
    // 日期选择
    goChooseDate(deliveryPlanTime, startDate) {
      this.$router.push({
        path: "/order/choosedate",
        query: {
          deliveryPlanTime: this.preCheckout.currentAvailableTime,
          totalPeriods: this.preCheckout.totalPeriods,
          periodInterval: this.preCheckout.periodInterval,
          purPage: "pur",
          defaultPlanTime: startDate
        }
      });
    },
    // 发货说明
    goExplain() {
      if (this.preCheckout.orderType === 1) {
        this.$router.push("/order/milkexplaintime");
      } else {
        this.$router.push("/order/explaintime");
      }
    },
    // 留言
    goNote() {
      this.$router.push({
        path: "/mine/cardnote",
        query: {
          purPage: "pur"
        }
      });
    },
    goOrder1() {
      this.$router.push("/agreement/order1");
    }
  }
};
</script>
<style lang="less" scoped>
.purchase_con {
  // background: #fff;
  .title_right {
    width: 36px;
  }
  .product_con_det {
    border-radius: 8px;
    background: #fff;
    margin-top: 12px;
    .product_pad {
      padding-bottom: 9px;
      background: #fff;
    }
    .pad_mr {
      margin-top: 10px;
    }
  }
  .free_product_list {
    background: #fff;
    padding: 0 12px 12px;
    .free_pad {
      padding: 0 20px;
    }
  }
  //
  .bao_name {
    padding: 4px 12px;
  }
  // 协议
  .det_all {
    margin: 12px 0 0;
  }
  .bottom_margin {
    height: 60px;
  }
  .det_color {
    color: rgba(191, 146, 100, 1);
  }
  .pro_padd {
    padding-bottom: 12px;
  }
}
</style>
